import actionCreator from '@/helpers/redux/actionCreator';

export const EDIT_FIELD_OPEN = '@/EDIT_FIELD_OPEN';
export const EDIT_FIELD_CLOSE = '@/EDIT_FIELD_CLOSE';

export const editFieldOpen = () => actionCreator(EDIT_FIELD_OPEN);
export const editFieldClose = () => actionCreator(EDIT_FIELD_CLOSE);
